/* Gem State Corals: estimates based on the store's current CORAL shipping profile. */
(() => {
  'use strict';
  const storageKey = 'gsc_shipping_region_v1';
  const regions = ['outside', 'idaho', 'pickup'];
  function selectedRegion() {
    try {
      const value = localStorage.getItem(storageKey);
      return regions.includes(value) ? value : 'outside';
    } catch (_) { return 'outside'; }
  }
  function storeRegion(region) {
    try { localStorage.setItem(storageKey, region); } catch (_) {}
  }
  function currency(cents, code) {
    try {
      return new Intl.NumberFormat('en-US', {style:'currency', currency:code || 'USD'}).format(cents / 100);
    } catch (_) {
      return '$' + (cents / 100).toFixed(2);
    }
  }
  function coralShipping(subtotal, region) {
    if (region === 'pickup' || subtotal >= 35000) return 0;
    if (region === 'idaho') return subtotal < 10000 ? 3500 : 2500;
    return subtotal < 10000 ? 5500 : 4500;
  }
  function paint(element) {
    const subtotal = Math.max(0, Number(element.dataset.gscSubtotal) || 0);
    const region = selectedRegion();
    const ship = coralShipping(subtotal, region);
    const select = element.querySelector('.gsc-cart-shipping__select');
    const rate = element.querySelector('[data-gsc-shipping-rate]');
    const total = element.querySelector('[data-gsc-estimated-total]');
    if (select) select.value = region;
    if (rate) {
      rate.textContent = ship === 0 ? 'FREE' : currency(ship, element.dataset.gscCurrency);
      rate.classList.toggle('is-free', ship === 0);
    }
    if (total) total.textContent = currency(subtotal + ship, element.dataset.gscCurrency);
  }
  function init() {
    document.querySelectorAll('[data-gsc-shipping-estimate]:not([data-gsc-ready])').forEach((element) => {
      element.setAttribute('data-gsc-ready', 'true');
      const select = element.querySelector('.gsc-cart-shipping__select');
      if (select) select.addEventListener('change', () => {
        const region = regions.includes(select.value) ? select.value : 'outside';
        storeRegion(region);
        document.querySelectorAll('[data-gsc-shipping-estimate]').forEach(paint);
      });
      paint(element);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  const observer = new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node.nodeType === 1 && (node.matches?.('[data-gsc-shipping-estimate]') || node.querySelector?.('[data-gsc-shipping-estimate]'))) {
          init();
          return;
        }
      }
    }
  });
  observer.observe(document.documentElement, {childList:true, subtree:true});
})();